import Axios from 'axios'
import * as constants from '../helpers/Constants.js'
import Models from '@/store/ORM/models.js';

const specialist = Axios.create({
  baseURL:constants.APIURL,
  withCredentials: false, // This is the default
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  }
})

specialist.interceptors.response.use((response) =>{
  return response
},  (error) =>{
  if (error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('loggedin');
      localStorage.removeItem('vuex');

      
      Models.Reference.deleteAll();
      Models.Supplier.deleteAll();
      Models.Specialist.deleteAll();
      Models.CreatedMenu.deleteAll();
      Models.Specialist.deleteAll();
      Models.Nutritionist.deleteAll();
      Models.Client.deleteAll();
      Models.Event.deleteAll();
      Models.Product.deleteAll();

      let urls = window.location.href.split('#');
      window.open(urls[0],'_self');
  }
  return Promise.reject(error)
})



const getSpecialistsEndpoint = "api/v1/specialists/all";
const referSpecialistsEndpoint = "api/v1/clients/refer-client";
const getClientReferencesEndpoint = "api/v1/clients/get-client-refer/";
const getClientCommisionEndpoint = "api/v1/clients/get-client-commission/";
const postSpecialistsEndpoint = "api/v1/specialists/contact";

export default {

  getSpceialists() {
    return specialist.get(getSpecialistsEndpoint);
  },
  referSpecialist(body){
    return specialist.post(referSpecialistsEndpoint,body);
  },
  getClientReferences(nutritionist_id,client_id){
    return specialist.get(getClientReferencesEndpoint+nutritionist_id+'/'+client_id);
  },
  getClientCommisionEndpoint(nutritionist_id,client_id){
    return specialist.get(getClientCommisionEndpoint+nutritionist_id+'/'+client_id);
  },
  sendContact(body){
    return specialist.post(postSpecialistsEndpoint,body);
  }
}
